"use strict";

require("core-js/modules/es6.array.some");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("@lsg/utils");

var React = __importStar(require("react"));

var CSSPrefix_1 = require("../../../base/CSSPrefix");

var index_1 = require("../../atoms/Icon/index");

var Picture_1 = require("../../atoms/Picture");

var Card_Shadow_png_1 = __importDefault(require("./images/Card-Shadow.png"));

var Cirrus_Black_svg_1 = __importDefault(require("./images/Cirrus-Black.svg"));

var Cirrus_White_svg_1 = __importDefault(require("./images/Cirrus-White.svg"));

var Flexicard_svg_1 = __importDefault(require("./images/Flexicard.svg"));

var Girocard_svg_1 = __importDefault(require("./images/Girocard.svg"));

var Infocard_svg_1 = __importDefault(require("./images/Infocard.svg"));

var Maestro_Black_svg_1 = __importDefault(require("./images/Maestro-Black.svg"));

var Maestro_White_svg_1 = __importDefault(require("./images/Maestro-White.svg"));

var MasterCard_Black_svg_1 = __importDefault(require("./images/MasterCard-Black.svg"));

var MasterCard_White_svg_1 = __importDefault(require("./images/MasterCard-White.svg"));

var Sparcard_svg_1 = __importDefault(require("./images/Sparcard.svg"));

var Visa_Black_svg_1 = __importDefault(require("./images/Visa-Black.svg"));

var Visa_White_svg_1 = __importDefault(require("./images/Visa-White.svg"));

var Cards;

(function (Cards) {
  Cards["GIRO"] = "giro";
  Cards["INFO"] = "info";
  Cards["SPAR"] = "spar";
  Cards["FLEXI"] = "flexi";
  Cards["EINZAHL"] = "einzahl";
})(Cards || (Cards = {}));

var Flags;

(function (Flags) {
  Flags["NONE"] = "none";
  Flags["CIRRUS"] = "cirrus";
  Flags["MAESTRO"] = "maestro";
  Flags["MASTERCARD"] = "mastercard";
  Flags["VISA"] = "visa";
})(Flags || (Flags = {}));

var BankingCard =
/** @class */
function (_super) {
  __extends(BankingCard, _super);

  function BankingCard() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      resizeAmount: 1
    };

    _this.onResize = function () {
      return _this.setState({
        resizeAmount: Math.min(1, _this.containerElm.offsetWidth / BankingCard.maxWidth)
      });
    };

    return _this;
  }

  BankingCard.prototype.componentDidMount = function () {
    utils_1.WindowEvents.addResizeCallback(this.onResize);
  };

  BankingCard.prototype.componentWillUnmount = function () {
    utils_1.WindowEvents.removeResizeCallback(this.onResize);
  };

  BankingCard.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        id = _a.id,
        className = _a.className,
        card = _a.card,
        flag = _a.flag,
        cardNumber = _a.cardNumber,
        expirationDate = _a.expirationDate,
        cardOwner = _a.cardOwner,
        tilted = _a.tilted,
        disabled = _a.disabled,
        noNFC = _a.noNFC;
    var resizeAmount = this.state.resizeAmount;
    var tilt = tilted ? "rotate(-10deg)" : "";
    var tiltModifier = this.props.tilted ? 0.9124 : 1;
    var isLightCard = [BankingCard.Cards.GIRO, BankingCard.Cards.FLEXI, BankingCard.Cards.INFO, BankingCard.Cards.SPAR, BankingCard.Cards.EINZAHL].some(function (cardType) {
      return card === cardType;
    });
    var imageSource = card === BankingCard.Cards.GIRO && Girocard_svg_1["default"] || card === BankingCard.Cards.FLEXI && Flexicard_svg_1["default"] || card === BankingCard.Cards.INFO && Infocard_svg_1["default"] || card === BankingCard.Cards.SPAR && Sparcard_svg_1["default"] || card === BankingCard.Cards.EINZAHL && Infocard_svg_1["default"];
    var flagSource = flag === BankingCard.Flags.CIRRUS && (isLightCard ? Cirrus_Black_svg_1["default"] : Cirrus_White_svg_1["default"]) || flag === BankingCard.Flags.MAESTRO && (isLightCard ? Maestro_Black_svg_1["default"] : Maestro_White_svg_1["default"]) || flag === BankingCard.Flags.MASTERCARD && (isLightCard ? MasterCard_Black_svg_1["default"] : MasterCard_White_svg_1["default"]) || flag === BankingCard.Flags.VISA && (isLightCard ? Visa_Black_svg_1["default"] : Visa_White_svg_1["default"]);
    return React.createElement("div", {
      id: id,
      className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "bankingcard-container", disabled && CSSPrefix_1.lsgPre + "bankingcard__disabled", className]),
      ref: function ref(r) {
        return _this.containerElm = r;
      }
    }, React.createElement("div", {
      style: {
        transform: tilted ? "translateY(" + 59 * resizeAmount + "px)" : "",
        transformOrigin: "top left"
      }
    }, React.createElement(Picture_1.Picture, {
      className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "bankingcard", !tilted && CSSPrefix_1.lsgPre + "bankingcard__shadow"]),
      src: imageSource,
      style: {
        transform: "scale(" + tiltModifier + ") " + tilt,
        transformOrigin: "top left"
      }
    }), React.createElement("div", {
      className: CSSPrefix_1.lsgPre + "bankingcard-contentwrapper",
      style: {
        transform: "scale(" + resizeAmount * tiltModifier + ") " + tilt,
        transformOrigin: "top left"
      }
    }, React.createElement("div", {
      className: CSSPrefix_1.lsgPre + "bankingcard-cardname"
    }, utils_1.Localization.texts.lsg.component.BankingCard.titles[card]), noNFC ? React.createElement("div", {
      className: CSSPrefix_1.lsgPre + "bankingcard-contactlesspalceholder"
    }) : React.createElement(index_1.Icon, {
      className: CSSPrefix_1.lsgPre + "bankingcard-contactlessicon",
      name: index_1.Icon.Names.banking___contactless,
      color: index_1.Icon.Colors.ANTHRACITE
    }), React.createElement("div", {
      className: CSSPrefix_1.lsgPre + "bankingcard-detailscontainer"
    }, React.createElement("div", {
      className: CSSPrefix_1.lsgPre + "bankingcard-cardnumber"
    }, React.createElement("div", {
      className: CSSPrefix_1.lsgPre + "bankingcard-cardnumber-label"
    }, utils_1.Localization.texts.lsg.component.BankingCard.cardNumber), React.createElement("div", {
      className: CSSPrefix_1.lsgPre + "bankingcard-cardnumber-value"
    }, cardNumber)), React.createElement("div", {
      className: CSSPrefix_1.lsgPre + "bankingcard-expiration"
    }, React.createElement("div", {
      className: CSSPrefix_1.lsgPre + "bankingcard-expiration-label"
    }, utils_1.Localization.texts.lsg.component.BankingCard.validThru), React.createElement("div", {
      className: CSSPrefix_1.lsgPre + "bankingcard-expiration-value"
    }, expirationDate))), React.createElement("div", {
      className: CSSPrefix_1.lsgPre + "bankingcard-bottomcontainer"
    }, React.createElement("div", {
      className: CSSPrefix_1.lsgPre + "bankingcard-owner"
    }, cardOwner), flag !== BankingCard.Flags.NONE && React.createElement(Picture_1.Picture, {
      src: flagSource,
      className: CSSPrefix_1.lsgPre + "bankingcard-typeflag"
    })))), tilted && React.createElement(Picture_1.Picture, {
      src: Card_Shadow_png_1["default"],
      className: CSSPrefix_1.lsgPre + "bankingcard__tilted-shadow",
      style: {
        transform: resizeAmount < 1 ? "scale(" + resizeAmount + ")" : "",
        transformOrigin: "left top",
        marginTop: 41 * resizeAmount + "px"
      }
    }));
  };

  BankingCard.Cards = Cards;
  BankingCard.Flags = Flags;
  BankingCard.maxWidth = 77 * 4;
  BankingCard.defaultProps = {
    card: BankingCard.Cards.GIRO,
    flag: BankingCard.Flags.NONE
  };
  return BankingCard;
}(React.Component);

exports.BankingCard = BankingCard;